import { render, staticRenderFns } from "./CompactEventsCalendar.vue?vue&type=template&id=13d3b2ae&scoped=true&"
import script from "./CompactEventsCalendar.vue?vue&type=script&lang=js&"
export * from "./CompactEventsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CompactEventsCalendar.vue?vue&type=style&index=0&id=13d3b2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3b2ae",
  null
  
)

export default component.exports